import React, { useCallback, useEffect, useState } from "react";
import { Pencil, Trash2, User } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../Redux/CommonSlice/allDataSlice";
import { APIEND_POINT, APIUtility } from "../../Api";
import NoData from "../../components/Common/NoData";
import Selectbox from "../../components/Common/Selectbox";
import Checkbox from "../../components/Common/Checkbox";
import { addToast } from "../../Redux/CommonSlice/toastSlice";
import Loader from "../../components/Common/Loader";
import ConfrimModal from "../../Modal/ConfrimModal";
import cameraImg from "../../images/cameraImg.png";

const CameraTable = ({
  headers,
  cameraData,
  fetchCamData,
  isTableloading,
  searchQuery,
  validateRTSP,
  permissions

}) => {
  const [editRowId, setEditRowId] = useState(null);
  const [editData, setEditData] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState(cameraData.map(() => []));
  const [ErrorMessage, setErrorMessage] = useState(null);
  const [confrimModalShow, setConfrimModalShow] = useState(false);
  const [cameraId, setCameraId] = useState(null);
  const camtableData = useSelector((state) => state.data.cameraData);
  const users = useSelector((state) => state.data?.userData || []);

  const dispatch = useDispatch();

  function filterUsersById(userlist, useridList) {
    return userlist
      .filter((user) => useridList.includes(user.id))
      .map((user) => ({ label: user.username, value: user.id }));
  }

  const handleEditClick = (camera) => {
    setEditRowId(camera.camera_id);

    setEditData({
      rtspLink: camera.rtsp_link,
      configuration: camera.name,
      user: filterUsersById(users, camera.user),
      qr_code_status: camera.qr_code_status,
    });
  };


  const handleInputChange = (e, id, field) => {
    setEditData((prev) => ({ ...prev, [field]: e.target.value, id }));
  };


  const handleSaveClick = async (id) => {
    setEditRowId(id);
    if (validateRTSP(editData.rtspLink)) {
      try {
        const selectedUserIds = editData?.user?.map((user) => {
          return user ? user.value : null;
        });

        const data = {
          id: editRowId,
          name: editData?.configuration,
          rtsp_link: editData?.rtspLink,
          user: selectedUserIds, // Use user IDs instead of usernames
          qr_code_status: editData?.qr_code_status,
        };

        const response = await APIUtility.UpdateCamera(data);
        if (response.status === 200) {
          setEditRowId(null);
          fetchCamData();
          dispatch(
            addToast({
              message: "Camera Details Updated Successfully",
              isError: false,
            })
          );
        } else {
          dispatch(
            addToast({ message: "Unable To Update Camera Details", isError: true })
          );
        }
      } catch (error) {
        console.error("Failed to add camera:", error);
        dispatch(
          addToast({
            message: error.message || error.Text || "Failed To Update Camera",
            isError: true,
          })
        );
      }
    } else {
      setErrorMessage("Enter Valid Camera Url Or rtsp link");
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
    }
  };

  const DeleteCameradata = async () => {
    const res = await APIUtility.DeleteCamera({ id: cameraId });
    if (res.status == 204) {
      fetchCamData();
      setCameraId(null);
      setConfrimModalShow(false);
    }
  };

  const filteredCamera = camtableData?.filter((user) =>
    user?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  return (
    <table className="min-w-full bg-white rounded border-b relative">
      <thead>
        <tr>
          {headers.map((header, index) => (

            (!permissions?.camera_delete_button || !permissions?.camera_edit_button) && header === 'Action' ? null :
              <th
                key={index}
                className={` bg-white sticky top-0 z-40 ${index !== headers.length - 1 ? "border-r" : ""
                  }`}
              >
                <div className="text-black opacity-50 w-full h-full text-[15px] font-medium border-b-2 border-tableBorder p-3 text-left ">
                  {header}
                </div>
              </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {isTableloading ? (
          <tr>
            <td className=" h-[400px] w-full " colSpan={5}>
              <div className="w-full h-full flex items-center justify-center">
                <Loader />
              </div>
            </td>
          </tr>
        ) : !filteredCamera ? (
          <tr>
            <td className=" h-[400px] w-full" colSpan={5}>
              <NoData text={"No Camera Found"} />
            </td>
          </tr>
        ) : (
          filteredCamera &&
          filteredCamera?.length == 0 && (
            <tr>
              <td className=" h-[300px] w-full" colSpan={5}>
                <NoData text={"No Camera Found"} />
              </td>
            </tr>
          )
        )}

        {filteredCamera?.map((camera, index) => (
          <tr key={camera.camera_id} className="border-b">
            <td
              className={
                editRowId === camera.camera_id
                  ? `p-2 ml-2  flex items-center text-black text-sm font-medium`
                  : `p-2 ml-2 mt-2 justify-start flex items-center text-black text-sm font-medium`
              }
            >
              {editRowId === camera.camera_id ? (
                <input
                  type="text"
                  placeholder={camera.name}
                  value={editData?.configuration}
                  onChange={(e) =>
                    handleInputChange(e, camera.id, "configuration")
                  }
                  className="text-black text-sm font-medium border-2 rounded p-3 w-[100%]"
                />
              ) : (
                <span className=" flex items-center gap-2">
                  <img
                    className="w-[60px] h-[40px] rounded-md object-fill"
                    src={camera?.cctv_image ? APIEND_POINT + camera?.cctv_image : cameraImg}
                  />
                  {camera.name}
                </span>
              )}
            </td>
            <td className="text-black text-sm font-medium border-r border-l p-2">
              {editRowId === camera.camera_id ? (
                <div className=" relative ">
                  <input
                    type="text"
                    value={editData?.rtspLink}
                    onChange={(e) =>
                      handleInputChange(e, camera.id, "rtspLink")
                    }
                    className="text-black text-sm font-medium border-2 rounded p-3 w-full"
                  />
                  {ErrorMessage && (
                    <p className=" m-0 text-red-600 text-[10px] absolute bottom-[-14px]">
                      {ErrorMessage}
                    </p>
                  )}
                </div>
              ) : (
                camera.rtsp_link
              )}
            </td>
            <td
              className={
                editRowId === camera.id
                  ? `text-black text-sm font-medium border-r px-3 ml-2`
                  : `text-black text-sm font-medium border-r px-3`
              }
            >
              <div className="flex items-center gap-2">
                <div className={editRowId === camera.id ? `` : ``}>
                  <User />
                </div>
                {editRowId === camera.camera_id ? (
                  <Selectbox
                    placeholder="Select a User"
                    containerClass="!w-full"
                    data={users.map((item) => ({
                      label: item.username,
                      value: item.id,
                    }))}
                    onSelect={(value) => {
                      setSelectedUsers(value);
                      setEditData((prev) => ({
                        ...prev,
                        user: value,
                        id: camera.id,
                      }));
                    }}
                    defaultValue={editData?.user?.map((item) => ({
                      value: item.value,
                      label: item.label,
                    }))}
                    multiselect
                    checkbox
                  />
                ) : (
                  <div>
                    {camera.user_names.length > 0 && (
                      <>
                        {camera.user_names[0]}
                        {camera.user_names.length > 1 && (
                          <span className="bg-customGreen text-white rounded-full py-1 px-2 ml-1">
                            {camera.user_names.length - 1}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            </td>
            <td className="border-r ml-2 p-2">
              <div className="flex w-full justify-center p-1">
                <button
                  className={`h-[45px] px-2 flex flex-wrap text-customGreen border-3 border-customGreen  rounded-sm w-full cursor-not-allowed ${editRowId === camera.camera_id
                    ? "opacity-100 pointer-events-auto"
                    : "opacity-40 pointer-events-none"
                    }`}
                >
                  <Checkbox
                    checked={camera.qr_code_status}
                    onChange={(value) => {
                      setEditData((prev) => ({
                        ...prev,
                        qr_code_status: value,
                        id: camera.camera_id,
                      }));
                    }}
                    labelText={"Enable QR Code"}
                    classNames="h-full w-full"
                  />
                </button>
              </div>
            </td>
            {
              (permissions?.camera_delete_button || permissions?.camera_edit_button) && <td>
                {editRowId === camera.camera_id ? (
                  <div className="px-2 w-full flex items-center gap-2">
                    <button
                      className="border font-normal p-2 rounded-md bg-customGreen text-white w-1/2 h-[45px]"
                      onClick={() => handleSaveClick(camera.camera_id)}
                    >
                      Update
                    </button>
                    <button
                      className="w-1/2 h-[45px] font-normal rounded-md bg-white border-2 text-black"
                      onClick={() => {
                        setEditRowId(null);
                        setEditData(null);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <div className="w-full flex justify-around px-4">
                    {
                      permissions?.camera_edit_button && <button
                        className="p-2 rounded bg-editIcon text-black "
                        onClick={() => handleEditClick(camera)}
                      >
                        <Pencil />
                      </button>
                    }

                    {
                      permissions?.camera_delete_button && <button
                        className="p-2 rounded text-black bg-red-200 "
                        onClick={() => {
                          setCameraId(camera.camera_id);
                          setConfrimModalShow(true);
                        }}
                      >
                        <Trash2 />
                      </button>
                    }


                  </div>
                )}
              </td>
            }

          </tr>
        ))}
      </tbody>

      <ConfrimModal
        heading="Delete Camera"
        message="Are you sure you want to delete this camera?"
        show={confrimModalShow}
        onHide={() => setConfrimModalShow(false)}
        onYesClick={DeleteCameradata}
      />
    </table>
  );
};

export default CameraTable;
